module.exports = __webpack_public_path__ + "static/media/box-shot.73e0fe1c.png";